import { flatten } from 'lodash';

function generateRegistrationFields(values: DistanceType[]): RegistrationFieldsType[] {
  const fields = values.map((distance) => distance.registration_fields || []);
  return flatten(fields);
}

export { generateRegistrationFields };
